/**
 *
 * @hack
 *
 * This is a dirty hack to fix URLs that have parenthesis and quotation marks in them
 * For example take this paragraph:
 *
 * """"
 * I visited this url: "http://www.wikipedia.com/some_article(with_paranthesis)"
 * and this URL: (http://www.wikipedia.com/some_article(with_paranthesis))
 * """"
 *
 * The quotation marks `'` `"` and parenthesis `(` `)` `[` `]`
 * can be considered to be part of the URL, and as a
 * punctuation marks surrounding the URL.
 * While this hack works for the most part, it's quite dirty and
 * I may replace it with something better in the future.
 *
 *
 * Another fix is removing punctuation marks that may appear at the end of URL
 * Example:
 *
 * """"
 * I've visited google.com, facebook.com, and yahoo.com.
 * """"
 *
 * @todo: replace the following function with something cleaner.
 *
 *
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function fixSeparators(arr, sep1, sep2) {
  arr.forEach(function (bit, i) {
    if (bit.indexOf(".") > -1 && !(arr[i - 1] === sep1 && arr[i + 1] === sep2) && (arr[i + 1] === sep1 || arr[i + 1] === sep2) // the one after it, is either sep1 or sep2
    ) {
      arr[i] = arr[i] + arr[i + 1];
      if (typeof arr[i + 2] === "string") arr[i] = arr[i] + arr[i + 2];
      if (typeof arr[i + 3] === "string") arr[i] = arr[i] + arr[i + 3];
      if (typeof arr[i + 4] === "string") arr[i] = arr[i] + arr[i + 4];
      arr.splice(i + 1, 4);
      fixSeparators(arr, sep1, sep2);
    }
  });
  return arr;
}
exports.fixSeparators = fixSeparators;
function default_1(arr) {
  arr = fixSeparators(arr, "(", ")");
  arr = fixSeparators(arr, "[", "]");
  arr = fixSeparators(arr, "\"", "\"");
  arr = fixSeparators(arr, "'", "'");
  return arr;
}
exports.default = default_1;